import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  // change the base url to point to the according service name
  protected baseUrl = this.env.API_BASE_URL + '/service/some-service-name/secure/';

  // add methods to post, put, get or delete from this api here
  // api files can be split up and should then be named according to the service they are calling
  // for instance, admin-authorization-api.service.ts, AdminAuthorizationApiService
}
